import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomContractCommandDto, FunnelPricingDto } from "api/pricing";
import { pricingAPI } from "services/swagger-api";

export const updateContractPrice = createAsyncThunk(
  'pricingValues/updateContractPrice',
  async (params: {
    contractFunnelId: string,
    contractIdentifier?: string
    , customContractCommandDto: CustomContractCommandDto
  }) => {
    const { contractFunnelId, contractIdentifier, customContractCommandDto } = params

    // Réponse : CustomContractResponseDto { isSuccess, tunnelId, tarification, errorMessage }.
    // On garde updateContractPriceRaw pour lire le JSON brut sans friction de type
    // (TarificationDto ~ FunnelPricingDto) et remonter aussi isSuccess/errorMessage :
    // une cartouche isSuccess=false (contrainte produit ou erreur de tarif) doit rester
    // désactivée et afficher errorMessage au lieu de mettre à jour le prix.
    const rawResponse = await pricingAPI.updateContractPriceRaw({
      customContractCommandDto: customContractCommandDto
    })
    const json = await rawResponse.raw.json()
    const newPrice: FunnelPricingDto = json.tarification ?? json

    return {
      contractFunnelId,
      contractIdentifier,
      isSuccess: json.isSuccess as boolean | undefined,
      errorMessage: (json.errorMessage ?? null) as string | null,
      newPrice,
    }
  }
);

